import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import templateModule from './modules/template';
import profileModule from './modules/profile';
import customerModule from './modules/customer';
import sharedModule from './modules/shared';
import orderModule from './modules/order';
import ontableModule from './modules/ontable';
import bookingsModule from './modules/bookings';
import cluvipayModule from './modules/cluvipay';
import websocketModule from './modules/websocket';
import couponModule from './modules/coupons';
import deliveryModule from './modules/delivery';
import { persistedState, restorePersistedState } from './persistence';
//import eventsSocket from './modules/plugins/events';

Vue.use(Vuex);
const vuexLocalStorage = new VuexPersistence({
  key: 'vuex',
  storage: window.localStorage,
  reducer: persistedState,
  restoreState: restorePersistedState
})
const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    shared:sharedModule, 
    template: templateModule,
    profile: profileModule, 
    bookings: bookingsModule, 
    ontable: ontableModule, 
    order: orderModule, 
    customer: customerModule, 
    cluvipay: cluvipayModule,
    websocket: websocketModule,
    coupons: couponModule,
    delivery: deliveryModule
  },
  plugins: [vuexLocalStorage.plugin, ],
  getters: {}
});


export default store;

